// That's config, which is shared between App and API
export const sharedConfig = {
  maxMessageLengthInBytes: 80,
  minDonationAmount: 1,
  minDonationCurrency: 'USD'
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/shared/shared-config.ts